import { AfterViewInit, Component, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Categoria } from 'src/app/consts/categoria';
import { AnexosReforma, AnexosReformaComponent } from '../anexos-reforma.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AdicionarCategoriaComponent } from '../adicionar-categoria/adicionar-categoria.component';
import { EventEmitter } from '@angular/core';
@Component({
  selector: 'app-tabela-categorias',
  templateUrl: './tabela-categorias.component.html',
  styleUrls: ['./tabela-categorias.component.css']
})
export class TabelaCategoriasComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() categorias: Categoria[] = [];
  @Input() anexo: any
  @Output() getAnexo = new EventEmitter<any>();
  @Output() excluirCategoriaOut = new EventEmitter<any>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: string[] = [
    'nome',
    'ncm',
    'cest',
    'naturezaReceita',
    'button'
  ];

  dataSource = new MatTableDataSource<Categoria>([]);

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['categorias']) {
      console.log("Categorias chegou no filho: ", this.categorias);
      this.dataSource.data = this.categorias
      console.log(this.anexo)
    }

    if (this.paginator) {
      this.dataSource.paginator = this.paginator
    }
  }

  AdicionarCategoria(){
    console.log(this.anexo)
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '60vw'
    dialogConfig.maxHeight = '85vh'
    dialogConfig.data = {
      AnexoId: this.anexo.Id,
      AnexoTitulo: this.anexo.Nome
    }
    console.log(dialogConfig)
    const dialogRef = this.dialog.open(AdicionarCategoriaComponent, dialogConfig)
    .afterClosed()
    .subscribe(response => {
      this.getAnexoReforma();
    }) 
  }

  excluirCategoria(element){
    this.excluirCategoriaOut.emit(element)
  }

  getAnexoReforma(){
    this.getAnexo.emit(this.anexo.Id)
  }
}
